module.exports = __webpack_public_path__ + "static/media/FireCompass-logo-white.3361889b.pdf";